export default __webpack_public_path__ + "static/media/Parking Space Regulations.44a5b1a5.pdf";